export default __webpack_public_path__ + "static/media/up_icons.cb704b85.svg";